import React, { useEffect, useRef, useState, memo, useMemo } from 'react'
import { createPortal } from 'react-dom'
import { Drawer, Box, Tabs, Input, Button } from '@mantine/core'
import { useProjectStore, useTbViewStore } from '@vt/hooks'
import { IconMapSearch } from '@tabler/icons'
import { useToggle } from '@mantine/hooks'
import { useRealAmap, Layer, clusterPlugin, markerPlugin } from '@ow/maps/lib'
import { fetchAmapSearch } from '@vt/apis/lib-ex/v2/map'
import { toNumber, last, pick, find } from 'lodash-es'
import { showNotification } from '@mantine/notifications'

export const useMarkerPortal = () => {
  const containerRef = useRef(document.createElement('div'))
  const InfoWindow = useMemo(
    () =>
      memo(({ children }) => {
        return createPortal(children, containerRef.current)
      }),
    []
  )
  return { InfoWindow, containerRef }
}
// import { get, pick } from 'lodash-es'
// import { useBeforeTransform, useTbViewStore } from '@vt/hooks'
// import ContainerRender from '../tables/container/container-render'

const mapConfig = {
  center: [116.478935, 39.997761],
  zoom: 15,
  reverseRefLayers: [],
  layers: [],
  mainLayer: {
    type: 'cluster',
    geoFieldSlug: 'lnglat',
    statistics: { show: 'count' },
    legends: [
      {
        title: '有问题',
        value: '有问题',
        markerIcon: 'markRed',
        mapColor: '#E34D59',
        queries: [
          {
            slug: 'pointSort',
            value: '有问题',
            queryType: ['equal'],
          },
        ],
      },
    ],
  },
}

const Map = function ({ clickedInfo }) {
  // 这个文件中实现的功能
  // 可显示所有点位, 高亮当前点位, 或仅显示当前点位
  // 可以汇集所有的 geo 字段在一起显示
  // 可以有打点模式

  const [addresses, setAddresses] = useState([])
  const [addressValue, setAddressValue] = useState()

  const { InfoWindow, containerRef } = useMarkerPortal()
  const [currentMarker, setCurrentMarker] = useState()

  const { ditto, tbData, updateTbData } = useTbViewStore((x) =>
    pick(x, [
      'ditto',
      // 'filters',
      // 'mapConfig',
      'updateTbData',
      'tbData',
    ])
  )

  const getVtProject = useProjectStore((state) => state.getVtProject)

  const { amapKey = '0e4f7b5e424e7db93755cb5d48e71a75' } = getVtProject()

  const mainLayer = useRef(
    new Layer(ditto, {
      legends: mapConfig.mainLayer.legends,
    })
  )

  const [isOpenModal, toggleModal] = useToggle(['close', 'open'])

  const { inited, getApis, getAmap } = useRealAmap(
    'viewmap',
    {
      amapKey,
      plugins: [clusterPlugin(), markerPlugin()],
      zoom: mapConfig.zoom,
      center: mapConfig.center,
    },
    () => {}
  )

  const searchByAddress = (_, val) => {
    fetchAmapSearch(
      '139b20c31dbd776abc98dbc187fba53b',
      val || addressValue
    ).then((data) => {
      if (data.pois) {
        const adds = data.pois.map((x) => {
          return {
            address: x.address,
            lnglat: x.location.split(','),
          }
        })
        setAddresses(adds)
      }
    })
  }

  const handleAddressInput = (e) => {
    // 搞个节流
    setAddressValue(e.target.value)
  }

  const addMarker = (point) => {
    mainLayer.current.addMarker(
      { ...point, content: containerRef.current },
      {
        onClick: () => {
          // setCurrentMarker({
          //   address: point.address,
          //   lnglat: point.lnglat.map((x) => toNumber(x)),
          // })
        },
        onDragend: (e) => {
          console.log('[4]', e.lnglat.pos)
          setCurrentMarker({
            address: point.address,
            lnglat: [e.lnglat.lng, e.lnglat.lat],
          })
        },
      }
    )
  }

  const handleMarkerClick = (point) => {
    return () => {
      console.log('[2]', point)

      addMarker(point)
      setCurrentMarker({
        address: point.address,
        lnglat: point.lnglat.map((x) => toNumber(x)),
      })
    }
  }

  const handleClickSetCurrentMarker = () => {
    if (!clickedInfo || !clickedInfo.clickedId) {
      return
    }
    ditto.fetchById(clickedInfo.clickedId).then((data) => {
      console.log('[4]', clickedInfo, currentMarker)
      updateTbData({
        ...data,
        objectId: clickedInfo.clickedId,
        lnglat: currentMarker.lnglat,
      }).then((x) => {
        showNotification({
          title: '设置成功',
          message: `已设置点位坐标为${currentMarker.lnglat}`,
        })
        console.log('[2]', x)
      })
    })
  }

  const getAncestors = (objectId) => {
    const data = find(tbData, (x) => x.objectId === objectId)
    const ancestors = [data]
    let { parentId } = data

    while (parentId) {
      // eslint-disable-next-line no-loop-func
      const ac = find(tbData, (x) => x.objectId === parentId)
      if (ac) {
        ancestors.unshift(ac)
        parentId = ac.parentId
      } else {
        break
      }
    }

    return ancestors
    // return data
  }

  useEffect(() => {
    if (!inited) return

    const { initCluster, initMarker } = getApis()
    initCluster(mainLayer.current, (layer) => {
      console.log(layer)
      layer.getData = () => {
        return Promise.resolve([
          {
            lnglat: [116.94362695072371, 40.31485881236605],
          },
        ])
      }
    })
    initMarker(mainLayer.current)

    if (clickedInfo && clickedInfo.clickedId) {
      const ancestors = getAncestors(clickedInfo.clickedId)
      const address = ancestors.map((x) => x.title).join('')

      const val = last(ancestors)
      console.log('[3]', val)
      if (val && val.lnglat && val.lnglat.length === 2) {
        getAmap().setCenter(val.lnglat)
        addMarker({ ...val, content: containerRef.current })
        setCurrentMarker({
          address: val.address,
          lnglat: val.lnglat,
        })
      }
      setAddressValue(address)
      searchByAddress(null, address)
    } else {
      console.log(clickedInfo)
    }
    // amap.setCurrentArea()

    // userPointRender(userList)
    // mainLayer.current.renderCluster()
  }, [inited, clickedInfo])

  return (
    <div className="w-full h-full flex flex-col">
      <div className="flex-1 w-full relative">
        <div id="viewmap" className="w-full h-full" />
        <Box className="absolute top-2 right-4 bg-white w-60">
          <Tabs defaultValue="search">
            <Tabs.List>
              <Tabs.Tab value="search">位置搜索</Tabs.Tab>
              <Tabs.Tab value="geo">点位绘制</Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value="search" pt="xs">
              <div className="flex flex-row">
                <Input
                  value={addressValue}
                  onChange={handleAddressInput}
                  placeholder="输入地址反查坐标"
                />
                <Button variant="outline" onClick={searchByAddress}>
                  <IconMapSearch />
                </Button>
              </div>
              <div className="max-h-56 overflow-auto">
                {addresses.map((x) => (
                  <div
                    className="cursor-pointer"
                    onClick={handleMarkerClick(x)}
                  >
                    {x.address}
                  </div>
                ))}
              </div>
            </Tabs.Panel>
            <Tabs.Panel value="geo" pt="xs">
              未实现
            </Tabs.Panel>
          </Tabs>
        </Box>
      </div>

      <div className="m-1 h-3">显示全部, 显示下级</div>
      <InfoWindow>
        <div>(关闭小窗可拖动图标到预期的位置)</div>
        {currentMarker && currentMarker.address}
        <Button onClick={handleClickSetCurrentMarker} variant="outline">
          使用此坐标作为点位坐标
        </Button>
      </InfoWindow>
      <Drawer
        opened={isOpenModal === 'open'}
        onClose={() => toggleModal()}
        title="点位详情"
        padding="l"
        size="l"
      >
        hello
        {/* Drawer content */}
      </Drawer>
    </div>
  )
}

export default Map
